// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../../engines/components/BasePopUpLayer";
import O1HD from "../../../../engines/gameEngine";
import data_control from "../../../../engines/libs/data_control";
import PromiseUtil from "../../../../engines/libs/PromiseUtil";
import utilsModel from "../../../../engines/libs/utilsModel";
import utilsView from "../../../../engines/libs/utilsView";
import { UIKind } from "../../../define/UIKind";
import { BUNDLE_SMALL_NAME } from "../../BundleResourceConfig";
import { SuperPowerConfig } from "./SuperPowerConfig";

const {ccclass, property} = cc._decorator;

@ccclass
export default class SuperPowerSelectLayer extends BasePopUpLayer {

	@property({ type: cc.Node, displayName:'' })
	nodeRoot: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	nodeSelect: cc.Node = null;
	@property({ type: cc.Node, displayName:'' })
	nodeEnd: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	nodeContent: cc.Node = null;

    @property(cc.Node)
    sprTalk: cc.Node = null;

    @property(cc.Label)
    labelTalk: cc.Label = null;

    @property(cc.Node)
    nodeAniPeople: cc.Node = null;
    @property(cc.Node)
    nodeAni: cc.Node = null;
    @property(cc.Node)
    spr_fazhen: cc.Node = null;
    @property(cc.Node)
    nodeBlack: cc.Node = null;

    @property(sp.Skeleton)
    spineAni: sp.Skeleton = null;
    
    private selectList: number[] = [];

    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        O1HD.getModules().uiControlModule.hideLoading();
        this.nodeContent.active = false;
        this.nodeEnd.active = false;
        this.spr_fazhen.active = false;
        this.nodeAni.active = false;
        this.nodeBlack.active = false;
        
        this.startAni();
    }

    initLayer() {
        this.refreshSelectList();
        this.startSelect();
    }

    protected onDestroy(): void {
        O1HD?.emit("normalMode.onBackNormal", UIKind.UILayerTag.SuperPowerSelectLayer);
    }

    async startAni() {

        this.spr_fazhen.active = true;
        this.nodeBlack.active = true;
        this.spr_fazhen.scale = 0;

        this.nodeBlack.opacity = 0;

        const cTime = 3;
        const fadeOut = 0.35;
        // 黑色背景
        cc.tween(this.nodeBlack)
        .to(0.15, {opacity: 200})
        .delay(1.8 + cTime)
        .to(fadeOut, {opacity: 90})
        .start();

        // 法阵旋转
        cc.tween(this.spr_fazhen)
        .by(2, {angle: 360})
        .repeatForever()
        .start();

        // 法阵显示
        cc.tween(this.spr_fazhen)
        .to(0.5, {scale: 1})
        .delay(2)
        .to(0.5, {opacity: 0})
        .start();
        
        await PromiseUtil.sleep(1.8);

        this.spineAni.setAnimation(0, 'animation', false);
        this.nodeAni.active = true;

       
        this.nodeAniPeople.y = cc.winSize.height/2 + this.nodeAniPeople.height/2;

        O1HD.getManagers().soundMgr.playSound("light", null, BUNDLE_SMALL_NAME.superPowerBundle);
        
        cc.tween(this.spineAni.node)
        .delay(cTime)
        .to(fadeOut, {opacity: 0})
        .start();

        cc.tween(this.nodeAniPeople)
        .to(cTime, {
            y: 11
        })
        .delay(fadeOut)
        .call(()=> {
            this.nodeAni.active = false;
            this.nodeBlack.active = false;
            this.spr_fazhen.active = false;
            this.initLayer();
        })
        .start();
    }

    async startSelect() {
        const strTalk = [
            '少侠，我们又见面了，你用上古阵法召唤了我，可以满足你一个愿望'
            , '不可以反悔哟，选择你的愿望吧'
        ]
        this.nodeContent.active = true;
        this.nodeSelect.active = false;
        this.sprTalk.active = false;
        await PromiseUtil.sleep(0.6);
        for (let i = 0; i < strTalk.length; i++) {
            let o = strTalk[i];
            this.showTextAni(o);
            if (i != strTalk.length - 1) {
                await PromiseUtil.sleep(2.6);
            }
        }
        this.nodeSelect.active = true;
        this.nodeSelect.opacity = 0;
        cc.tween(this.nodeSelect)
        .to(0.25, {opacity: 255})
        .start();
    }

    refreshSelectList() {
        this.selectList = [];

        let len = SuperPowerConfig.SelectConfig.length;
        let dataList = this.selectList = data_control.randomIntNum(0, len-1, 4);
        let nodeSelect = this.nodeSelect.getChildByName('nodeSelect');
        let children = nodeSelect.children;
        let i = 0;
        for (let o of dataList) {
            let itemConfig = SuperPowerConfig.SelectConfig[o];
            let item = children[i];
            if (!item) {
                console.log('节点超限');
                return;
            }
            let label = item.getChildByName('labelName').getComponent(cc.Label);
            label.string = itemConfig.name;
            i++;
        }
    }

    /**
     * 显示文本动画
     * @param text 
     */
    async showTextAni(text: string) {
        this.sprTalk.active = true;
        this.sprTalk.opacity = 0;
        this.labelTalk.string = text;
        cc.tween(this.sprTalk).to(0.2,{opacity:255}).start();
    }

    closeTextAni() {
        this.sprTalk.active = false;
    }

    async showEndUI(
        strTalk: string = null
        , bCloseTalk: boolean = true
        , delayTime: number = null
    ) {
        this.nodeEnd.active = true;
        if (bCloseTalk) {
            this.closeTextAni();
        }
        
        if (strTalk) {
            this.showTextAni(strTalk);
        }

        let dt = 2;
        if (delayTime) {
            dt = delayTime;
        }
        await PromiseUtil.sleep(dt);

        cc.tween(this.node)
        .to(0.25, {opacity: 0})
        .call(
            () => {
                this.destroyNode();
            }
        )
        .start();
    }

    onClickEndConfirm() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.destroyNode();
    }

    async onClickSelect(event: cc.Event.EventTouch, data) {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.nodeSelect.active = false;
        let idx = Number(data) - 1;
        let listIdx = this.selectList[idx];
        let itemConfig = SuperPowerConfig.SelectConfig[listIdx];
        if (!itemConfig) {
            console.error('言出法随配置有误');
            return;
        }

        let len = itemConfig.talkList.length;
        for (let i = 0; i < len; i++) {
            let o = itemConfig.talkList[i];
            this.showTextAni(o);
            if (i != len - 1) {
                await PromiseUtil.sleep(2.6);
            }
        }
        utilsView.openPopupLayer(
            'prefab/items/' + itemConfig.prefabName
            , BUNDLE_SMALL_NAME.superPowerBundle
            , this.nodeRoot
            , {
                parent: this
            }
        );
    }

    onClickRefresh() {
        O1HD.getManagers().soundMgr.playSound("anNiu");

        utilsModel.loadAndShowVideoAdTrans(()=>{
            this.refreshSelectList();
        },()=>{
 
        }, null, "刷新愿望");
    }
    

    // update (dt) {}
}
